import styled from "styled-components";

export const ContainerNoText = styled.div`
    margin-top: 19px
`